import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { environment } from 'src/environments/environment';
import { ContentServiceService } from 'src/app/service/content-service.service';
import { DatePipe } from '@angular/common';
import { SubscriptionService } from 'src/app/service/subscription.service';
import { PortalService } from 'src/app/service/portal.service';
import { AgencyService } from 'src/app/service/agency.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  showModalBox: boolean = false;
  wifiModalBox: boolean = false;
  dayModalBox: boolean = false;
  subModalBox: boolean = false;
  invalidNo: boolean = false;
  discrib: boolean = false;
  subbtn: boolean = false;
  homepageData: any;
  categoryData: any;
  homeSliderData: any;
  trendingGamesData: any;
  newadditionsGamesData: any;
  feelingAdventurousGamesData: any;
  actionPackedGamesData: any;
  downloadResponse: any;
  msisdn: string;
  subcriptionDetails: any;
  msg: string;
  discrb: string;

  customOptionsOwl: OwlOptions = {
    items: 1,
    nav: false,
    dots: true,
    margin: 0,
    loop: true,
  };
  gamesOwl: OwlOptions = {
    items: 1.5,
    nav: false,
    dots: false,
    margin: 15,
    loop: true,
  };
  newgamesOwl: OwlOptions = {
    items: 3,
    nav: false,
    dots: false,
    margin: 15,
    loop: true,
  };
  catOwl: OwlOptions = {
    items: 4,
    nav: false,
    dots: false,
    margin: 15,
    loop: true,
  };

  constructor(private contentService: ContentServiceService,
    private agencyService: AgencyService,
    private subscriptionService: SubscriptionService,
    private portalService: PortalService,
    private datePipe: DatePipe,
  ) { }

  async ngOnInit() {
    await this.agencyService.setAgencyParameters();
    localStorage.setItem('redirectsub', '0')
    this.msisdn = localStorage.getItem('msisdn');
    // check subscribeUser
    await this.subscriptionService.checkSubscription();

    if (sessionStorage.getItem('isSubscribed') == '0') {
      this.subbtn = true
    }
    this.getHomePageData();
    this.getCategory();
  }

  subModal() {
    this.subModalBox = true;
  }
  dayModal() {
    this.dayModalBox = true
  }
  wifiModal() {
    this.wifiModalBox = true
  }
  showModal() {
    console.log("click");
    this.showModalBox = true
  }
  invalidModal() {
    this.invalidNo = true
  }
  discribModal(i, dis) {
    this.discrib = true;
    this.discrb = dis
  }
  closeModal() {
    this.dayModalBox = false;
    this.showModalBox = false;
    this.subModalBox = false;
    this.discrib = false;
    console.log("click");
    //  this._router.navigateByUrl('/home')
  }
  closeinvalidModal() {
    this.invalidNo = false
    // this.spinner.hide();
  }
  homeSlider() {
    let trending_id_filter = ["Top Banner"];
    this.homeSliderData = this.homepageData.filter(function (item) {
      return trending_id_filter.indexOf(item.categoryname) !== -1;
    });
    console.log("this.homepage", this.homeSliderData);
  }

  trendingGames() {
    let trending_id_filter = ["Trending Game"];
    this.trendingGamesData = this.homepageData.filter(function (item) {
      return trending_id_filter.indexOf(item.categoryname) !== -1;
    });
    console.log("trendingGamesData", this.trendingGamesData);
  }

  feelingAdventurousGames() {
    let feeling_id_filter = ["Feeling Adventurous"];
    this.feelingAdventurousGamesData = this.homepageData.filter(function (item) {
      return feeling_id_filter.indexOf(item.categoryname) !== -1;
    });
    console.log("feelingAdventurousGamesData", this.feelingAdventurousGamesData);

  }
  newAdditionsGames() {
    let new_id_filter = ["New Additions"];
    this.newadditionsGamesData = this.homepageData.filter(function (item) {
      return new_id_filter.indexOf(item.categoryname) !== -1;
    });
    console.log("newadditionsGamesData", this.newadditionsGamesData);
  }

  actionPackedGames() {
    let action_id_filter = ["Action Packed"];
    this.actionPackedGamesData = this.homepageData.filter(function (item) {
      return action_id_filter.indexOf(item.categoryname) !== -1;
    });
    console.log("actionPackedGamesData", this.actionPackedGamesData);
  }

  getHomePageData() {
    let endpoint = "portal/homePage";
    let data = {
      "data": {
        "portalid": environment.portalid,
      }
    }

    this.contentService.getContentById(data, endpoint)
      .then(response => {
        if (response['success']) {
          console.log("Success..", response)
          this.homepageData = response['data']['serviceContent'];
          console.log("homepageData", this.homepageData);

          this.homeSlider();
          this.trendingGames();
          this.feelingAdventurousGames();
          this.newAdditionsGames();
          this.actionPackedGames();
        }
      })
      .catch(error => {
        console.log("Error", error);
        //this._router.navigate(['/content-management/portal'])
      })

  }

  getCategory() {
    let endpoint = "portal/portalCategory";
    let data = {
      "data": {
        "portalid": environment.portalid,
      }
    }

    this.contentService.getContentById(data, endpoint)
      .then(response => {
        if (response['success']) {
          console.log("Success..", response)
          this.categoryData = response['data']['serviceContent'];
          console.log("categoryData", this.categoryData);
        }
      })
      .catch(error => {
        console.log("Error", error);
      })
  }

  async click() {
    let msisdn = localStorage.getItem('msisdn');

    console.log('NO MSISDN');
    if (msisdn == null || msisdn == undefined || msisdn == 'NA') {
      //  console.log('NO MSISDN 2');
      this.wifiModal()

    } else {
      //insertCGLog
      await this.subscriptionService.insertCGLog();
      await this.subscriptionService.getCGDetails();
      this.msg = localStorage.getItem('msg');
    }
  }

  //downloadLog   this
  downloadLog(contentName) {
    this.portalService.downloadLogEntry(contentName)
  }

}

